export default {

    "title": "Protocol details",
    "entityName": "protocol_detail",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "name",
        "descending": false
    },
    "fields": [
        // {
        //     slim:true,
        //     value: "name",
        //     text: "Name",
        //     type: "text",
        //     readonly: true,
        // },
        {
            slim:true,
            "value": "countries",
            "text": "Countries",
            "type": "textarea",
        },
        {
            med:true,
            "value": "title",
            "text": "Title",
            "type": "textarea",
            "table": { "filter": true },
            "validators": [
                "required"
            ]
        },

        {
            slim:true,
            "value": "protocol_number",
            "text": "Protocol number",
            "type": "text",
            "validators": [
                "required"
            ]         
        },

        {
            slim:true,
            "value": "coordinator",
            "text": "Coordinator",
            "type": "text",
        },

        {
            slim:true,
            "value": "funder",
            "text": "Funder",
            "type": "text",
        },

        {
            slim:true,
            "value": "status",
            "text": "Status",
            "type": "text",
        },

        {
            slim:true,
            "value": "pm",
            "text": "Project manager",
            "type": "text",
        },

        {
            slim:true,
            "value": "tm",
            "text": "Trial start up",
            "type": "text",
        },

        {
            slim:true,
            "value": "cdm",
            "text": "CDM",
            "type": "text",
        },

        {
            slim:true,
            "value": "safety",
            "text": "Pharmaco Vigilance",
            "type": "text",
        },

        {
            slim:true,
            "value": "statistician",
            "text": "Statistics",
            "type": "text",
        },

        {
            slim:true,
            "value": "trial_master_file",
            "text": "Trial master file",
            "type": "text",
        },


        {
            slim:true,
            "value": "imp",
            "text": "Imp",
            "type": "text",
        },

        {
            slim:true,
            "value": "monitoring",
            "text": "Monitoring",
            "type": "text",
        },

        {
            slim:true,
            "value": "central_labs",
            "text": "Central labs",
            "type": "text",
        },

        {
            slim:true,
            "value": "patient_number",
            "text": "Patient number",
            "type": "text",
        },

        {
            slim:true,
            "value": "fpi",
            "text": "FPI",
            "type": "text",
        },

        {
            slim:true,
            "value": "lpi",
            "text": "LPI",
            "type": "text",
        },

        {
            slim:true,
            "value": "lpo",
            "text": "LPO",
            "type": "text",
        },

        {
            slim:true,
            "value": "fu",
            "text": "FU",
            "type": "text",
        },

        {
            slim:true,
            "value": "it",
            "text": "IT consultant",
            "type": "text",
        },

        {
            slim:true,
            "value": "steering_commitee",
            "text": "Steering commitee",
            "type": "text",
        },

        {
            slim:true,
            "value": "medical_monitors",
            "text": "Medical monitos",
            "type": "text",
        },

        
        // {
        //     "value": "n_patients",
        //     "text": "N. max patients",
        //     "type": "number",
        //     "table": {
        //         "sortable": true,
        //         "filter": true
        //     },            
        //     "validators": [
        //         "required",
        //         "number"
        //     ]
        // },
          
    ],
    "actions": [
        { "value": "edit", "text": "Edit", "icon": "mdi-pencil", "color": "primary" },
        "remove",
        // { "value": "export", "text": "Export", "icon": "mdi-microsoft-excel", "color": "primary" }
    ]
}